import React from 'react';

interface QuestionCardProps {
  points: number | string;
  earnedPoints?: number;
  children: React.ReactNode;
  className?: string;
  hidePointsIcon?: boolean;
  questionNumber?: number;
  'data-test-id'?: string;
  'data-test-type'?: string;
}

/**
 * QuestionCard - Common wrapper for all question types
 * Provides consistent layout with points badge and card styling
 */
const QuestionCard: React.FC<QuestionCardProps> = ({
  points,
  earnedPoints,
  children,
  className = '',
  hidePointsIcon = false,
  questionNumber,
  'data-test-id': dataTestId,
  'data-test-type': dataTestType
}) => {
  const pointsDisplay = () => {
    if (earnedPoints !== undefined) {
      // Results mode - show earned/potential format
      const potentialPoints = typeof points === 'number' ? points : parseInt(String(points));
      return `${earnedPoints}/${potentialPoints} PTS`;
    }
    // Selection mode - show just potential points
    return typeof points === 'number' ? `${points} PTS` : points;
  };

  return (
    <div
      className={`bg-game-card rounded-xl p-4 ${className}`}
      data-test-id={dataTestId}
      data-test-type={dataTestType}
    >
      {/* Header with Question Number and Points */}
      {!hidePointsIcon && (
        <div className="flex items-center justify-between mb-4">
          {/* Question Number Circle */}
          {questionNumber && (
            <div className="w-8 h-8 bg-bet99-green rounded-full flex items-center justify-center">
              <span className="text-white font-gilroy font-bold">{questionNumber}</span>
            </div>
          )}

          {/* Points Display */}
          <span className="text-white font-gilroy ml-auto">
            {pointsDisplay()}
          </span>
        </div>
      )}

      {/* Question Content */}
      {children}
    </div>
  );
};

export default QuestionCard;